import React from "react"
import classNames from "classnames"

const Office = ({
  city,
  gmb,
  heading,
  mode = "dark", // dark or light
  state,
  streetName,
  streetNumber,
  zip,
  linkTitle = "Get directions to our office"
}) => {
  const streetFormat = `${streetNumber} ${streetName}`
  const cityStateFormat = `${city}, ${state} ${zip}`

  const wrapperClasses = classNames({
    "office-address": true,
    [`${mode}`]: true
  })

  return (
    <div className={wrapperClasses}>
      {heading && <p className="bold office-address__heading">{heading}</p>}

      {gmb ? (
        <a
          aria-label="open in new tab"
          href={gmb}
          target="_blank"
          title={linkTitle}>
          <p className="office-address__line">{streetFormat}</p>
          <p className="office-address__line">{cityStateFormat}</p>
        </a>
      ) : (
        <>
          <p className="office-address__line">{streetFormat}</p>
          <p className="office-address__line">{cityStateFormat}</p>
        </>
      )}
    </div>
  )
}

export default Office
